var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div>\n  <div class=\"cell\"><span class=\"label\">{{ t('fleetDelCallLog') }}</span>\n    <div ng-repeat=\"callLog in customer.callLogs\"><span>{{ callLog.timestampCalled | moment: 'LT' }}</span></div>\n  </div>\n  <div ng-if=\"drivers\" class=\"cell\"><span class=\"label\">{{ t('fleetDelCallLogDriver') }}</span>\n    <div ng-repeat=\"callLog in customer.callLogs\"><span>{{ driverName(callLog.driverUsername, drivers) }}</span></div>\n  </div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/customerCallLogTooltip.jade
 ** module id = 19
 ** module chunks = 1
 **/